import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ProductHttpService } from 'src/app/http/product-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
declare var $: any;

@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styles: [],
})
export class ProductListComponent implements OnInit, AfterViewInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
        private productHttpService: ProductHttpService,
        private router: Router
    ) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    sections = [];

    searchBoxControl = new FormControl();

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    filterContent = new FormControl();

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
        this.filterContentChange();
    }

    ngAfterViewInit(): void {
        $('.selectpicker').selectpicker();
    }

    filterContentChange() {
        this.filterContent.valueChanges.subscribe((data) => {
            console.log(data);
        });
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data[0];
            this.tempItems = data.data[0];
            this.sections = data.data[1];
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.productName.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    confirmTogglePublish(item: any, value: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `${value ? 'Publish' : 'Unpublish'}`;
        confirm.componentInstance.messageLabel = `Are you sure you want to ${value ? 'publish' : 'unpublish'}  this item?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.togglePublish(item, value);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.productHttpService.deleteProduct(item.productId).subscribe(() => {
            this.deleteItem(item.productId);
            this.alert.addAlert({ type: 'success', message: 'Product Deleted successfully' });
        });
    }

    togglePublish(item: any, value: any) {
        this.productHttpService.togglePublishProduct(item.productId, value).subscribe(() => {
            this.togglePublishItem(item.productId, value);
            this.alert.addAlert({ type: 'success', message: `Product ${value ? 'publish' : 'unPublish'} successfully` });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.productId != itemId);
        this.items = this.tempItems;
    }

    togglePublishItem(itemId: any, value: any) {
        let item = this.tempItems.find((c) => c.productId === itemId);
        item.isPublished = value;
        this.items = this.tempItems;
    }

    contentTypeSelect() {
        console.log('select');
    }
}
